<nz-layout>
  <nz-header>
    <div class="app-header d-flex align-items-center">
      <app-menu-header></app-menu-header>
    </div>
  </nz-header>
   @if (isLoggedIn$ | async) {
    <app-sub-header></app-sub-header>
   }
  <nz-layout>
    @if(isLoggedIn$ | async) {
      <nz-sider class="menu-sidebar mt-4" nzCollapsible [nzWidth]="appSignalDataService.isCollapsedMenuAside$() ? '60px' : '256px'" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed"
        [nzTrigger]="null">
        <app-menu-aside></app-menu-aside>
      </nz-sider>
    }
    <nz-content>
      <div class="inner-content" [ngClass]="{ 'p-0 m-0': !(isLoggedIn$ | async) }">
        <!-- @if (isLoggedIn$ | async) {
          <app-header-page></app-header-page>
         } -->
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
  <nz-footer><p class="text-center mb-0">
    Copyright ©{{year}} - CNseg - Todos os direitos reservados.
  </p></nz-footer>
</nz-layout>

<app-loader class="no-print"></app-loader>

<nz-back-top [nzTemplate]="tpl" [nzVisibilityHeight]="100">
  <ng-template #tpl>
    <div class="ant-back-top-inner" nz-tooltip nzTooltipTitle="Subir ao Topo">
      <i class="fi fi-rr-angle-up text-white"></i>
    </div>
  </ng-template>
</nz-back-top>
<div style="position: fixed; bottom: 5px; right: 10px; font-size: 10px; color: gray;">
  v{{ version }}
</div>
